import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges, ElementRef } from '@angular/core';

@Component({
  selector: 'app-lesson-card',
  templateUrl: './lesson-card.component.html',
  styleUrls: ['./lesson-card.component.scss'],
  standalone: false
})
export class LessonCardComponent implements OnInit, OnChanges {
  @Input() index!: number;
  @Input() quizId: string = '';
  @Output() viewLesson = new EventEmitter<number>();
  @Input() quizTitle: string = '';
  @Input() learnDescription: string = '';
  @Input() difficultyLevel!: string | number;
  @Input() imageUrl: string | null = null;

  // True when imageUrl fails to load; shows the fallback placeholder instead
  imageError: boolean = false;

  // Cache cleaned description to avoid recalculation on each change detection
  private _cleanDescription: string = '';

  constructor(private readonly _elRef: ElementRef<HTMLElement>) {}

  /** Called by parent components to restore keyboard focus after navigating back. */
  public focusPrimaryButton(): void {
    const btn = this._elRef.nativeElement.querySelector<HTMLElement>('.sdl-btn-section button');
    btn?.focus();
  }

  ngOnInit(): void {
    // Initialize with the selected date if provided
    this._cleanDescription = this.stripHtmlTags(this.learnDescription);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Update cleaned description when learnDescription changes
    if (changes['learnDescription']) {
      this._cleanDescription = this.stripHtmlTags(this.learnDescription);
    }
    // Retry loading when a new image URL is provided
    if (changes['imageUrl']) {
      this.imageError = false;
    }
  }

  onImageError(): void {
    this.imageError = true;
  }

  onViewLesson() {
    this.viewLesson.emit(this.index);
  }

  get cleanDescription(): string {
    return this._cleanDescription;
  }

  private stripHtmlTags(html: string): string {
    if (!html) return '';
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }
}
